import React, { useMemo, useRef, useState } from 'react';
// eslint-disable-next-line no-restricted-imports -- TODO: legacy connect (baseline)
import { connect } from 'react-redux';
import Input from '../../components/input/input';
import FormattedMessage from '../../components/formatted-message';
import PropsFormatter, { tr } from '../../containers/props-formatter';
import { AuthContainer, AuthError, AuthForm, AuthHeader, AuthSubmitButton, AuthText } from './components/auth-layout';
import { isEmailValid } from '../../utils/regex-utils';
import Action from '../../containers/rest-query/action';
import { decodeSearchUrl } from '../../utils/api/path-utils';
import { Redirect } from 'react-router-dom';
import { isPasswordValid } from '../../utils/password-utils';
import { notEmptyPredicate } from '../../utils/helpers/check-condition-utils';
import { AuthOptionLinks, LOGIN_AUTH_LINK, SIGN_UP_AUTH_LINK } from './auth-option-links';
import Recaptcher, { CHECK_RECAPTCHA, recaptchaKey } from '../../components/recaptcher/recaptcher';
import { RecaptcherWrapper } from '../../components/recaptcher/recaptcher-styled-components';
import { languageSelectorForRecaptcha } from '../../redux/modules/locale';

const resetPasswordQuery = ({ password, token, recaptchaToken }) => ({
    method: 'POST',
    url: '/api/users/func/update-password',
    params: { password, token, recaptchaToken }
});

const requestResetPasswordQuery = ({ email, recaptchaToken }) => ({
    method: 'POST',
    url: '/api/users/func/reset-password',
    params: { email, recaptchaToken }
});

// eslint-disable-next-line tpe/max-component-size -- TODO: legacy large component (baseline)
const ResetPassword = props => {
    const { token } = decodeSearchUrl();

    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [validationMode, setValidationMode] = useState(false);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const [recaptchaToken, setRecaptchaToken] = useState('');

    const captchaRef = useRef();

    const { hl } = props;

    const handleCaptchaReady = resp => {
        setRecaptchaToken(resp);
    };
    const handleCaptchaError = respError => {
        /*eslint-disable*/
        console.error(respError);
        /*eslint-enable*/
        setRecaptchaToken('');
    };

    const handleCaptchaExpire = () => {
        /*eslint-disable*/
        console.error('Captcha expire!');
        /*eslint-enable*/
        setRecaptchaToken('');
    };

    const handleRecaptchaUpdate = () => {
        setRecaptchaToken('');
        if (!!captchaRef && !!captchaRef.current) {
            captchaRef.current.reset();
        }
    };

    const submitEnabled = useMemo(() => (token ? isPasswordValid(password) : isEmailValid(email)), [
        email,
        password,
        token
    ]);

    const resetPasswordButtonIsDisable = useMemo(() => {
        return (validationMode && !submitEnabled) || (CHECK_RECAPTCHA && (!recaptchaToken || recaptchaToken === ''));
    }, [validationMode, submitEnabled, recaptchaToken]);

    if (notEmptyPredicate(token) && notEmptyPredicate(success)) {
        return <Redirect to="/login" />;
    }

    return (
        <AuthContainer>
            <AuthForm>
                <AuthHeader>
                    <FormattedMessage id="resetPassword.title" />
                </AuthHeader>
                {success ? (
                    token ? (
                        <AuthText>
                            <FormattedMessage id="resetPassword.successNotification" />
                        </AuthText>
                    ) : (
                        <AuthText>
                            <FormattedMessage id="resetPassword.emailNotification" />
                        </AuthText>
                    )
                ) : (
                    <>
                        {token ? (
                            <>
                                <PropsFormatter
                                    validationPredicate={validationMode && isPasswordValid}
                                    placeholder={tr('resetPassword.newPassword')}
                                >
                                    <Input
                                        type="password"
                                        value={password}
                                        onChange={input => setPassword(input.target.value)}
                                        unbounded
                                    />
                                </PropsFormatter>
                                <Action
                                    query={resetPasswordQuery}
                                    variables={{ token, password, recaptchaToken }}
                                    notifyOnFailure={false}
                                    onSuccess={() => setSuccess(true)}
                                    onFailure={() => setError(true)}
                                >
                                    {({ performAction, processing }) => (
                                        <AuthSubmitButton
                                            disabled={resetPasswordButtonIsDisable || processing}
                                            onClick={e => {
                                                e.preventDefault();
                                                handleRecaptchaUpdate();
                                                if (submitEnabled) {
                                                    performAction();
                                                } else {
                                                    setValidationMode(true);
                                                }
                                            }}
                                            isLoading={processing}
                                        >
                                            <FormattedMessage id="resetPassword.button" />
                                        </AuthSubmitButton>
                                    )}
                                </Action>
                            </>
                        ) : (
                            <>
                                <PropsFormatter
                                    validationPredicate={validationMode && isEmailValid}
                                    placeholder={tr('resetPassword.login')}
                                >
                                    <Input
                                        type="text"
                                        value={email}
                                        onChange={input => setEmail(input.target.value)}
                                        unbounded
                                    />
                                </PropsFormatter>
                                <Action
                                    query={requestResetPasswordQuery}
                                    variables={{ email, recaptchaToken }}
                                    notifyOnFailure={false}
                                    onSuccess={() => setSuccess(true)}
                                    onFailure={() => setError(true)}
                                >
                                    {({ performAction, processing }) => (
                                        <AuthSubmitButton
                                            disabled={resetPasswordButtonIsDisable || processing}
                                            onClick={e => {
                                                e.preventDefault();
                                                handleRecaptchaUpdate();
                                                if (submitEnabled) {
                                                    performAction();
                                                } else {
                                                    setValidationMode(true);
                                                }
                                            }}
                                            isLoading={processing}
                                        >
                                            <FormattedMessage id="resetPassword.button" />
                                        </AuthSubmitButton>
                                    )}
                                </Action>
                            </>
                        )}
                        {!!CHECK_RECAPTCHA && (
                            <RecaptcherWrapper>
                                <Recaptcher
                                    ref={captchaRef}
                                    recaptchaKey={recaptchaKey}
                                    onVerify={handleCaptchaReady}
                                    onError={handleCaptchaError}
                                    onExpire={handleCaptchaExpire}
                                    hl={hl}
                                    id={`Recaptcher-Reset-Password`}
                                />
                            </RecaptcherWrapper>
                        )}
                    </>
                )}
                {!!error && (
                    <AuthError>
                        <FormattedMessage id="signUp.error" />
                    </AuthError>
                )}
            </AuthForm>
            <AuthOptionLinks linksToShow={[SIGN_UP_AUTH_LINK, LOGIN_AUTH_LINK]} />
        </AuthContainer>
    );
};

const mapStateToProps = state => {
    const hl = languageSelectorForRecaptcha(state);

    return {
        hl
    };
};

export default connect(mapStateToProps)(ResetPassword);
